import React from "react";
import personal from "assets/images/svg/personal_info_bg2.svg";
import { Link } from "react-router-dom";
import { useAuthContext } from "store/auth";
import { t } from "i18next";

const AccountSettingsPage = () => {
  const [{ user }] = useAuthContext();
  return (
    <div className="accountSettings ">
      <div className="row">
        <div className="col-lg-4 col-md-6">
          <h1 className="title">{t("profile:account-setting-page.title")as string}</h1>
          <p className="content">{t("profile:account-setting-page.content")as string}</p>
          <label className="subscribe">
            <input type="checkbox" name="subscribe" id="subscribe" checked={!user.isSuspended} />
            <span></span>
            <h3>
              {t("profile:account-setting-page.info")as string}
              <b className={user.isSuspended ? "inactive" : "active"}> {user.isSuspended ? t("common:sort.inactive")as string : t("common:sort.active")as string}</b>
            </h3>

            {user.isSuspended ? (
              <p>
                {t("profile:account-setting-page.isSuspendendSorry")as string}
                <Link to="/" className="contact">
                  {t("profile:account-setting-page.contactSupport")as string}{" "}
                </Link>
                {t("profile:account-setting-page.forInfo")as string}{" "}
              </p>
            ) : (
              <p>{t("profile:account-setting-page.currentStatusText")as string} </p>
            )}
          </label>
        </div>
        <div className="col-lg-8 col-md-6">
          <img className="img-fluid background" src={personal} alt="back-img" />
        </div>
      </div>
    </div>
  );
};

export default AccountSettingsPage;
